import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function createLightningScenarioAPI(scenario) {
  const url = `${AWS_API_URL}/lighting/scenarios`;

  return postRequest(url, mapDataForBackend(scenario), await authorize());
}
